export default function minutesToRead(words?: number): number {
  return Math.floor(0.0077 * (words || 0))
}
